import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Phone, Users, MessageSquare, Calendar } from 'lucide-react';

const outcomes = [
  { icon: Phone, label: 'More answered calls' },
  { icon: Users, label: 'More worked leads' },
  { icon: MessageSquare, label: 'More follow-up' },
  { icon: Calendar, label: 'More booked jobs' },
];

export const RevenueFlowSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <section
      ref={sectionRef}
      className="py-20 relative"
      data-testid="revenue-flow-section"
    >
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            How Revenue Grows
          </h2>
          <p className="text-lg text-white/60 max-w-xl mx-auto">
            A simple system that turns more leads into closed jobs.
          </p>
        </motion.div>

        {/* Outcome cards - clean and simple */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10"
        >
          {outcomes.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 15 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-white/3 border border-white/6"
            >
              <div className="w-10 h-10 rounded-lg bg-[#32D583]/15 flex items-center justify-center">
                <item.icon className="w-5 h-5 text-[#32D583]" />
              </div>
              <span className="text-sm text-white/70 text-center">{item.label}</span>
            </motion.div>
          ))}
        </motion.div>

        {/* Simple value prop */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="text-center p-6 rounded-2xl bg-[#32D583]/5 border border-[#32D583]/15"
        >
          <p className="text-white/80 mb-2">
            We don't just set up systems—<span className="text-[#32D583] font-medium">we help turn them into revenue.</span>
          </p>
          <p className="text-sm text-white/50">
            More from the leads you already have. Less money walking out the door.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
